import { TELEMEDICINE_CATEGORY_IDS } from '@/constants/category';

export const BRIDGE_PAGE_CATEGORIES: readonly string[] = [
  TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD,
  TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS,
];
